import { AppDispatch } from "../../../store";
import { saveTicketInternalNote } from "../../../store/thunks/ticketingPortalThunk";

export type CloseTicketFeedback = {
  msg: string;
  type: "success" | "error" | "info" | "warning";
};

export type CloseTicketRcaMeta = {
  categoryId: number;
  subCategoryId: number;
  rcaCategory: string;
  rcaNotes: string;
  resolution: string;
  resolvedBy: string;
};

const buildRcaNoteText = (meta: CloseTicketRcaMeta): string => {
  return [
    "[RCA - FINAL NOTE]",
    `RCA Category: ${meta.rcaCategory}`,
    `Resolved By: ${meta.resolvedBy}`,
    `RCA Notes: ${meta.rcaNotes}`,
    `Resolution: ${meta.resolution}`,
  ].join("\n");
};

export const closeTicketWithRca = async (params: {
  dispatch: AppDispatch;
  ticketId: string;
  meta: CloseTicketRcaMeta;
  performCloseUpdate: (meta: CloseTicketRcaMeta) => Promise<void>;
  successMessage?: string;
}): Promise<CloseTicketFeedback> => {
  const { dispatch, ticketId, meta, performCloseUpdate, successMessage } = params;

  try {
    const noteSaved = await dispatch(saveTicketInternalNote(ticketId, buildRcaNoteText(meta)) as any);
    if (!noteSaved) {
      return {
        msg: "Failed to save RCA note.",
        type: "error",
      };
    }

    await performCloseUpdate(meta);

    return {
      msg: successMessage ?? "Ticket marked as Closed and RCA note logged.",
      type: "success",
    };
  } catch (error: any) {
    return {
      msg: error?.message || "Failed to close ticket. Please try again.",
      type: "error",
    };
  }
};
